import React from 'react';
import imagePath from '../../../assets/images/blogs/Online vs offline learning thumbnail.png'


const TimeManagementStudyHabits = () => {

    return (
        <div className="container my-5">
            <img
                src={imagePath}
                alt="Time Management and Study Habits"
                className="img-fluid rounded mb-4 w-100"
                style={{ maxHeight: '400px', objectFit: 'cover' }}
            />

            <h1 className="mb-3">Time Management and Effective Study Habits</h1>

            <p>
                Time management is the art of consciously deciding how to allocate your hours and energy toward different activities. For students, it's the foundation of <strong>academic success, mental well-being, and personal growth</strong>. Mastering it helps reduce stress, boosts productivity, and enables balance between studies and hobbies.
            </p>

            <h4 className="mt-4">⏳ Why Time Management Matters</h4>
            <p>
                Your time is limited – once gone, it doesn't come back. That’s why it’s essential to use every moment wisely. Managing time well leads to better decision-making, discipline, and reduced last-minute pressure. It helps you plan your day with intention rather than just reacting to it.
            </p>

            <h4 className="mt-4">✅ Daily Time Management Tips</h4>
            <ul>
                <li>📝 Start your morning by writing down all tasks you need to complete.</li>
                <li>🎯 Focus first on important tasks or deadlines to ensure you stay on track.</li>
                <li>📦 Break big projects into smaller tasks to make them feel less overwhelming.</li>
                <li>🧠 Focus on one task at a time to avoid burnout and boost efficiency.</li>
            </ul>

            <h4 className="mt-4">📚 Smart Study Habits for Students</h4>
            <ul>
                <li>🙋‍♂️ Don’t hesitate to ask teachers for help or clarification.</li>
                <li>🧩 Avoid skipping lectures—missing them can leave big knowledge gaps.</li>
                <li>🖊️ Actively take notes during class instead of passive listening.</li>
                <li>🔁 Don’t just re-read notes—actively engage with them.</li>
                <li>🧠 Use mind maps and diagrams to visualize key concepts.</li>
                <li>📢 Explain difficult topics aloud to better understand them.</li>
                <li>❓ Create your own quiz questions to test yourself.</li>
                <li>🃏 Use flashcards to reinforce memory with active recall.</li>
                <li>🛋️ Set up a clean, quiet, well-lit space just for studying.</li>
            </ul>

            <h4 className="mt-4">🌟 Benefits of Time Management</h4>
            <p>
                Managing your time helps you avoid last-minute cramming, reduces anxiety, and improves academic performance. Combined with effective study habits, it leads to more meaningful learning and long-term success.
            </p>

            <p className="mt-4 text-muted">– Manjap, student of Mrs. Yogita Kumar</p>
        </div>
    );
};

export default TimeManagementStudyHabits;
